export class VentajaProyecto {
    cantidadGaleria?: number = 0;
    idVentaja?: number = 0;
    idIcono?: number = 0;
    idProyecto?: number = 0;
    idEmpresaAfiliada?: number = 0;
    nombre?: string = "";
    fechaHoraUM?: Date = new Date();
}


// Converts JSON strings to/from your types
export class Convert {
    public static toModelo(json: string): VentajaProyecto[] {
        return JSON.parse(json);
    }

    public static ventajaProyectoToJson(value: VentajaProyecto[]): string {
        return JSON.stringify(value);
    }
}
